import eventIngressSql from "./sql/0001_event_ingress.sql";

export const EMBEDDED_EVENT_INGRESS_LEDGER = "athena_event_ingress_migrations";

export const EMBEDDED_EVENT_INGRESS_REQUIRED_TABLES = [
	"event_ingress",
	"event_ledger",
	"event_outbox",
] as const;

export const EMBEDDED_EVENT_INGRESS_MIGRATIONS = [
	{
		checksum: "event-ingress-v1",
		filename: "0001_event_ingress.sql",
		name: "event_ingress",
		sql: eventIngressSql,
		version: 1,
	},
] as const;
